import {
  GermanCalculationType,
  GermanCalculatorInstallmentPeriod,
  GermanCalculatorPerpetualAnnuity,
  GermanCalculatorResultType,
  GermanCalculatorState,
} from '../types/german-calculator.type';

export const GERMAN_CALCULATOR_ONE_TIME_INVESTMENT_INITIAL_STATE: GermanCalculatorState = {
  config: {
    defaultResultType: GermanCalculatorResultType.CHART,
    formValues: {
      calculationTypeItems: [],
      bindValues: {
        defaultCalculationType: GermanCalculationType.END_VALUE,
        initialContribution: '10000',
        finalCapital: '14025',
        initialSalesCharge: '0',
        investmentPeriod: '5',
        interestRate: '5',
      },
      maxValues: {
        maxInitialContribution: '100000',
        maxFinalCapital: '100000',
        maxSalesCharge: '20',
        maxInvestmentPeriod: '100',
        maxInterestRate: '100',
      },
      maxLabelValues: null,
      invalidLabelValues: null,
    },
  },
};

export const GERMAN_CALCULATOR_SAVINGS_PLAN_INITIAL_STATE: GermanCalculatorState = {
  config: {
    defaultResultType: GermanCalculatorResultType.CHART,
    formValues: {
      calculationTypeItems: [],
      bindValues: {
        defaultCalculationType: GermanCalculationType.END_VALUE,
        initialContribution: '1000',
        finalCapital: '14025',
        savingsRate: '50',
        initialSalesCharge: '0',
        investmentPeriod: '5',
        interestRate: '5',
        defaultInstallmentPeriod: GermanCalculatorInstallmentPeriod.MONTHLY,
      },
      maxValues: {
        maxInitialContribution: '100000',
        maxFinalCapital: '100000',
        maxSavingsRate: '1000',
        maxSalesCharge: '20',
        maxInvestmentPeriod: '100',
        maxInterestRate: '100',
      },
      maxLabelValues: null,
      invalidLabelValues: null,
    },
  },
};

export const GERMAN_CALCULATOR_WITHDRAWL_PLAN_INITIAL_STATE: GermanCalculatorState = {
  config: {
    defaultResultType: GermanCalculatorResultType.CHART,
    formValues: {
      calculationTypeItems: [],
      bindValues: {
        defaultCalculationType: GermanCalculationType.INITIAL_CAPITAL,
        initialContribution: '38399',
        pension: '250',
        investmentPeriod: '20',
        finalCapital: '0',
        initialSalesCharge: '0',
        interestRate: '5',
        defaultPerpetualAnnuity: GermanCalculatorPerpetualAnnuity.NO,
        defaultPayout: GermanCalculatorInstallmentPeriod.MONTHLY,
      },
      maxValues: {
        maxInitialContribution: '100000',
        maxPension: '10000',
        maxInvestmentPeriod: '100',
        maxFinalCapital: '100000',
        maxSalesCharge: '20',
        maxInterestRate: '100',
      },
      maxLabelValues: null,
      invalidLabelValues: null,
    },
  },
};
